import { addDays, isBeforeDay, isSameDay } from "../Calendar/dates.js";
//#region src/components/DateRangePicker/presets.ts
/** Common presets, computed from today. Each takes an optional label. */
var dateRangePresets = {
	/** The last `days` days, today included. */
	lastDays: (days, label = `Last ${days} days`) => ({
		label,
		range: (today) => ({
			start: addDays(today, 1 - days),
			end: today
		})
	}),
	/** January 1 to today. */
	thisYear: (label = "This year") => ({
		label,
		range: (today) => ({
			start: new Date(today.getFullYear(), 0, 1),
			end: today
		})
	}),
	/** Last calendar year, January 1 to December 31. */
	lastYear: (label = "Last year") => ({
		label,
		range: (today) => ({
			start: new Date(today.getFullYear() - 1, 0, 1),
			end: new Date(today.getFullYear() - 1, 11, 31)
		})
	})
};
/**
* The preset's range for today, clamped to min/max, or null when it is incomplete or
* wholly outside them (the preset is then disabled).
*/
function resolvePreset(preset, today, min, max) {
	const range = typeof preset.range === "function" ? preset.range(today) : preset.range;
	if (!range.start || !range.end) return null;
	const start = min && isBeforeDay(range.start, min) ? min : range.start;
	const end = max && isBeforeDay(max, range.end) ? max : range.end;
	return isBeforeDay(end, start) ? null : {
		start,
		end
	};
}
/** Whether two ranges cover the same days (a missing end matches a missing end). */
function isSameRange(a, b) {
	const same = (x, y) => !x && !y || isSameDay(x, y);
	return same(a.start, b.start) && same(a.end, b.end);
}
//#endregion
export { dateRangePresets, isSameRange, resolvePreset };

//# sourceMappingURL=presets.js.map